import React from "react";

export const CONTACT = {
  linkedin: "https://www.linkedin.com/in/stine-eskesen-45b088aa/",
  instagram: "https://www.instagram.com/stineeskesen.dk/",
  emails: ["stineeskesen@me.com"],
  phone: "+45 28 55 85 44",
  phoneHref: "tel:+4528558544",
  doubleyou: "https://www.doubleyou-partners.com",
};

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
    <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

export const SocialLinks = ({ className = "", iconClass = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <a
      href={CONTACT.linkedin}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="LinkedIn"
      data-testid="preview-social-linkedin"
      className={`inline-flex h-11 w-11 items-center justify-center rounded-full border border-black/10 text-[#111827]/70 transition-all duration-300 hover:border-[#852936] hover:text-[#852936] ${iconClass}`}
    >
      <LinkedInIcon />
    </a>
    {CONTACT.instagram && (
      <a
        href={CONTACT.instagram}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        data-testid="preview-social-instagram"
        className={`inline-flex h-11 w-11 items-center justify-center rounded-full border border-black/10 text-[#111827]/70 transition-all duration-300 hover:border-[#852936] hover:text-[#852936] ${iconClass}`}
      >
        <InstagramIcon />
      </a>
    )}
  </div>
);

export default SocialLinks;
